import { useOutletContext } from 'react-router-dom';
import VolumeChart from './components/VolumeChart';

const VolumeTab = () => {
  const { volume_by_route } = useOutletContext();
  return <VolumeChart data={volume_by_route} />;
};

export default VolumeTab;
